// Description: This endpoint is used to start a channel in the database.
// Updated: 21/08/2025
// Author: Vitor de Jesus

import axios from 'axios';

export async function ChannelConnect(Code) {
    try {

        const token = localStorage.getItem('jwt_token');
        const clientId = localStorage.getItem('idToken');

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!clientId) throw new Error('ID do cliente não encontrado');
        const response = await fetch(`${process.env.REACT_APP_BACKEND_AWS_URL}/channels/start`, {
            method: "PUT",
            body: JSON.stringify({ code: Code }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${token}`,
                'Client_ID': `${clientId}`
            },
        });

        const responseData = await response.json();

        if (response.status === 200 && responseData.message === 'Configuração do canal definida com sucesso') {

            responseData.status = 'OK';

        } else {

            responseData.status = 'ERROR';

        }

        return responseData;
    } catch (error) {
        console.error('Erro ao buscar dados da API:', error);
        throw new Error('Erro ao buscar dados da API');
    }
}